import {
  FormattedHTMLMessage,
  FormattedMessage,
  defineMessages,
  injectIntl,
} from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { getTickets } from '../../../../ducks/event';
import { giftTicket } from '../../../../ducks/seatmap';
import { navigate } from '../../../../helpers';
import Input from '../../../Account/components/Input';
import Loader from '../../components/Loader';
import Option from '../components/Option';
import styles from '../seatmap.scss';
import withUser from '../../../../components/withUser';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      ticketId: PropTypes.string,
    }),
    url: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  tickets: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })),
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    shortcode: PropTypes.string,
  }),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

const messages = defineMessages({
  inputLabel: {
    id: 'seatmap.gift.index.inputLabel',
    defaultMessage: 'Email address',
  },
  inputExplanation: {
    id: 'seatmap.gift.index.inputExplanation',
    defaultMessage: 'This email will receive the ticket',
  },
  inputPlaceholder: {
    id: 'seatmap.gift.index.inputPlaceholder',
    defaultMessage: 'Type the email address here',
  },
  sendTicket: {
    id: 'seatmap.gift.index.sendTicket',
    defaultMessage: 'Send ticket',
  },
});

class Gift extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
    };
  }

  componentDidMount() {
    const {
      dispatch,
      user,
      event,
    } = this.props;

    if (user && user.id && event) {
      dispatch(getTickets(event.id));
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { dispatch, event: oldEvent, user: oldUser } = this.props;
    const { event, user } = newProps;
    if ((user && !oldUser) || (!oldEvent && event) || (oldEvent && oldEvent.id !== event.id)) {
      dispatch(getTickets(event.id));
    }
  }

  onGiftTicket = (ticket) => {
    const { email } = this.state;
    const { dispatch, event, history } = this.props;
    dispatch(giftTicket(event.id, ticket.id, email))
      .then((data) => {
        if (data) {
          navigate(history, {
            pathname: `/tickets/${event.shortcode}/gift/${ticket.id}/done`,
            state: {
              gifted: email,
            },
          });
        }
      });
  }

  render() {
    const { email } = this.state;
    const {
      tickets,
      match: { params },
      loading,
      intl,
    } = this.props;
    const { ticketId } = params;
    const { formatMessage } = intl;
    const doneTicket = tickets && tickets.find((ticket) => ticket.id === ticketId);
    return (
      <>
        <Loader loading={loading} />
        { tickets && doneTicket
          && (
            <>
              <div className={styles.title}>
                <FormattedMessage
                  id="seatmap.gift.index.title"
                  defaultMessage="Who do you want to give this ticket to?"
                />
              </div>
              <div className={styles.description}>
                <FormattedHTMLMessage
                  id="seatmap.gift.index.description"
                  defaultMessage="You are giving away a <strong>{ticketTypeName}</strong> ticket. Enter the the email address of the person you want to give the ticket to. They will receive an email with ticket instructions."
                  values={{
                    ticketTypeName: doneTicket.ticket_type.name,
                  }}
                />
              </div>
              <div className={styles.input}>
                <Input
                  id="email"
                  label={formatMessage(messages.inputLabel)}
                  explanation={formatMessage(messages.inputExplanation)}
                  placeholder={formatMessage(messages.inputPlaceholder)}
                  type="email"
                  onChange={(event) => this.setState({ email: event.target.value })}
                  stretch
                />
              </div>
              <Option
                icon="gift"
                title={formatMessage(messages.sendTicket)}
                onClick={() => this.onGiftTicket(doneTicket)}
                disabled={email?.length <= 3}
              />
            </>
          )}
      </>
    );
  }
}

Gift.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    event: state.getIn(['event', 'data']),
    error: state.getIn(['event', 'error']),
    loading: state.getIn(['event', 'loading']),
    tickets: state.getIn(['event', 'tickets']),
  };
}

export default injectIntl(withUser(connect(mapStateToProps)(Gift)));
